import { useState } from 'react'
import { DateTime } from 'luxon'
import { HiDocumentReport } from 'react-icons/hi'
import { api } from '../../../../api/api'
import { maskCurrency } from '../../../../utils/utils'

export function PeriodReport({ type }) {
  const isProducts = type === 'products'
  const [dates, setDates] = useState({
    startDate: DateTime.local().startOf('month').toISODate(),
    endDate: DateTime.local().toISODate(),
  })
  const [rows, setRows] = useState([])
  const [searched, setSearched] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function generate(event) {
    event.preventDefault()
    if (!dates.startDate || !dates.endDate || dates.startDate > dates.endDate) {
      setError('Informe um período válido: a data inicial não pode ser posterior à final.')
      return
    }

    setLoading(true)
    setError('')
    setSearched(false)
    setRows([])
    try {
      const endpoint = isProducts ? '/product-order/report/sold' : '/orders/report/daily'
      const response = await api.get(endpoint, { params: dates })
      setRows(response.data ?? [])
      setSearched(true)
    } catch (requestError) {
      setError(requestError.response?.data?.message ?? 'Não foi possível gerar o relatório.')
    } finally {
      setLoading(false)
    }
  }

  const quantity = rows.reduce((sum, row) => sum + Number(isProducts ? row.totalQuantity : row.count), 0)
  const total = rows.reduce((sum, row) => sum + Number(row.total), 0)

  return (
    <section className="mt-3 pb-5">
      <div className="p-2 bg-dark-blue-1 rounded fw-bold border mb-3">
        <h2 className="text-white m-0" style={{ fontSize: '1.3rem' }}>
          <HiDocumentReport className="mb-1" size={22} /> {isProducts ? 'Produtos vendidos' : 'Vendas por dia'}
        </h2>
      </div>

      <form className="row border p-2 pb-3 g-2 mx-0" onSubmit={generate}>
        <div className="col-sm-4 col-md-3">
          <label htmlFor={`${type}-start-date`} className="text-gray">Início</label>
          <input id={`${type}-start-date`} type="date" required className="form-control form-control-sm"
            value={dates.startDate} onChange={(event) => setDates({ ...dates, startDate: event.target.value })} />
        </div>
        <div className="col-sm-4 col-md-3">
          <label htmlFor={`${type}-end-date`} className="text-gray">Fim</label>
          <input id={`${type}-end-date`} type="date" required className="form-control form-control-sm"
            value={dates.endDate} onChange={(event) => setDates({ ...dates, endDate: event.target.value })} />
        </div>
        <div className="col-sm-4 col-md-2 d-flex align-items-end">
          <button type="submit" className="btn btn-sm btn-dark-blue w-100" disabled={loading}>Gerar relatório</button>
        </div>
      </form>

      {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}
      {loading && <p className="mt-3 text-dark" role="status">Carregando relatório...</p>}
      {searched && !loading && (
        <div className="table-responsive mt-3">
          <table className="table table-sm">
            <thead>
              <tr>
                <th scope="col">{isProducts ? 'Produto' : 'Data'}</th>
                <th scope="col">{isProducts ? 'Quantidade vendida' : 'Vendas'}</th>
                {!isProducts && <th scope="col">Valor total</th>}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={isProducts ? row.idProduct : row.date}>
                  <td>{isProducts ? row.nameProduct : DateTime.fromISO(row.date).toFormat('dd/MM/yyyy')}</td>
                  <td>{isProducts ? row.totalQuantity : row.count}</td>
                  {!isProducts && <td>{maskCurrency(row.total)}</td>}
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={isProducts ? 2 : 3} className="text-center text-muted py-4">Nenhuma venda encontrada no período.</td></tr>
              )}
            </tbody>
            {rows.length > 0 && (
              <tfoot>
                <tr className="fw-bold">
                  <td>Total do período</td>
                  <td>{quantity}</td>
                  {!isProducts && <td>{maskCurrency(total)}</td>}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}
    </section>
  )
}
